"use client";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

interface ActivityCardSkeletonProps {
  count?: number;
}

export function ActivityCardSkeleton({ count = 1 }: ActivityCardSkeletonProps) {
  return (
    <>
      {Array.from({ length: count }).map((_, index) => (
        <div
          key={index}
          className="max-h-[380px] bg-white rounded-xl overflow-hidden shadow-lg border border-gray600/10"
        >
          {/* Image placeholder */}
          <div className="relative">
            <Skeleton height={150} className="w-full" />
          </div>

          {/* Content placeholder */}
          <div className="p-4 h-1/2">
            {/* Category and tag */}
            <div className="flex items-center">
              <Skeleton width={80} height={16} className="text-xs" />

              <Skeleton
                width={60}
                height={16}
                className="ml-3 text-xs rounded-3xl"
              />
            </div>

            {/* Title */}
            <Skeleton height={20} width="80%" className="text-base my-1" />

            <hr className="text-gray500/5 my-2" />

            {/* Date and location */}
            <div className="flex items-center mt-2">
              <Skeleton circle width={12} height={12} className="mr-1" />
              <Skeleton width={120} height={12} />
            </div>

            {/* Attendees and rating */}
            <div className="flex items-center mt-2">
              <Skeleton circle width={12} height={12} className="mr-1" />
              <Skeleton width={80} height={12} className="mr-2" />
              <Skeleton circle width={12} height={12} className="mx-1" />
              <Skeleton width={60} height={12} />
            </div>
          </div>
        </div>
      ))}
    </>
  );
}
